import queryString from 'query-string'
import { APIVersion, AuthenticatedFileRequest, AuthenticatedRequest, HTTPMethod, Session, BasicRequest } from "../requests/request";
import { SubAccount } from '..';


export interface Report {
    id: string;
    view_path: string;
    name: string;
    num_cols: number;
    num_rows: number;
    pos_x: number;
    pos_y: number;
}
export interface ReportData{

}
export interface ReportSection {
    name: string;
    components: DXDatasource[]
}
export type ReportContentTypeOptions = 'Chart' | 'Datagrid'
export type ReportContentTypeNarrative = 'Narrative'
export interface DXDatasourceNarrative {
    id: string
    title: string
    type: ReportContentTypeNarrative
    location: {
        col: number
        row: number
        width: number
        height: number
    },
    text: string
}
export interface DXDatasourceData {
    id: string
    title: string
    type: ReportContentTypeOptions
    location: {
        col: number
        row: number
        width: number
        height: number
    },
    source: Array<any>
    index_type: 'daily' | 'weekly' | 'monthly'
    series: Array<string>
}
export type DXDatasource = DXDatasourceData | DXDatasourceNarrative

export class API {

    public static addClient(client: SubAccount): Promise<SubAccount> {
        let apiRequest = new AuthenticatedRequest<SubAccount>('/clients', HTTPMethod.POST, APIVersion.v1_0, undefined, client);

        return apiRequest.send(SubAccount).then((response) => {
            return response.data;
        });
    }

    public static deleteClient(client: SubAccount): Promise<void> {
        let apiRequest = new AuthenticatedRequest<void>('/clients/' + client.id, HTTPMethod.DELETE, APIVersion.v1_0);

        return apiRequest.send().then((response) => {
            return void 0;
        });
    }

    public static saveClientView(client: SubAccount, view: any): Promise<void> {
        let apiRequest = new AuthenticatedRequest<void>('/clients/' + client.id + '/views', HTTPMethod.PUT, APIVersion.v1_0, undefined, { view });
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }

    public static getClients(): Promise<Array<SubAccount>> {
        let apiRequest = new AuthenticatedRequest<SubAccount>('/clients', HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send(SubAccount).then((response) => {
            return response.data;
        });
    }

    public static getReports(client: SubAccount): Promise<Array<Report>> {
        let apiRequest = new AuthenticatedRequest<Report>('/reports/' + client.id, HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    public static getReportData(client: SubAccount, file_name: string): Promise<any>  {
        const params = {file_name}
        let apiRequest = new AuthenticatedRequest<Report>('/reportData/' + client.id + '?' + queryString.stringify(params), HTTPMethod.GET, APIVersion.v1_0);
        return apiRequest.send().then((response) => {
            return response.data;
        })
    }

    public static getNarrative(client: SubAccount, params: any): Promise<any>  {
        // const params = {file_name}
        let apiRequest = new AuthenticatedRequest<Report>('/reportNarrative/' + client.id + '?' + queryString.stringify(params), HTTPMethod.GET, APIVersion.v1_0);
        return apiRequest.send().then((response) => {
            return response.data;
        })
    }
    public static emailReport(client: SubAccount, reports: Report[], month: number): Promise<void> {
        let array_path = reports.reduce((prev, current) => {
            prev += '&view_ids=' + current.id
            return prev
        }, '')
        let apiRequest = new AuthenticatedRequest<Report>('/reports/subaccount/' + client.id + '/email', HTTPMethod.GET, APIVersion.v1_0, { month_index: month, view_ids: reports.map(r => r.id) });

        return apiRequest.send().then((response) => {
            return void 0;
        });
    }

    public static getReportImageLink(client: SubAccount, report: Report, month: number): string {
        return Session.getAPIURL() + '/' + APIVersion.v1_0 + '/reports/' + report.id + '/image?token=' + Session.getSession()! + '&month_index=' + month + '&sub_account=' + client.id
    }

    public static getReportPdfLink(client: SubAccount, report: Report, month: number, download: boolean = false): string {
        return Session.getAPIURL() + '/' + APIVersion.v1_0 + '/reports/' + report.id + '/pdf?token=' + Session.getSession()! + '&month_index=' + month + '&sub_account=' + client.id + (download ? '&download=1' : '')
    }

    public static getFullReportPdfLink(client: SubAccount, reports: Report[], month: number): string {
        let array_path = reports.reduce((prev, current) => {
            prev += '&view_ids=' + current.id
            return prev
        }, '')
        return Session.getAPIURL() + '/' + APIVersion.v1_0 + '/reports/subaccount/' + client.id + '/full?token=' + Session.getSession()! + '&month_index=' + month + '' + array_path
    }

    public static uploadLogo(client: SubAccount, image: any): Promise<SubAccount> {
        let apiRequest = new AuthenticatedFileRequest<SubAccount>('/clients/' + client.id + '/logo', HTTPMethod.POST, APIVersion.v1_0, undefined, {
            image
        });

        return apiRequest.send(SubAccount).then((response) => {
            return response.data;
        });
    }

    public static getReportSection(client: SubAccount, sectionId: string, start_index: number, end_index: number) {
        let apiRequest = new AuthenticatedRequest<ReportSection>('/report/' + client.id + '/' + sectionId, HTTPMethod.GET, APIVersion.v2_0, { start_index, end_index });

        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/endpoints/client.ts